// Configuration for the User block, mirroring featured/Gallery/config.

// Google Identity Services client id for the "Sign in with Google" button.
export const GOOGLE_CLIENT_ID =
  "104732163593-i3k7gm7msmoeabqf1i0o3ek1hbuhfpnn.apps.googleusercontent.com";

// Number of boxes in the one-time-code field.
export const CODE_LENGTH = 6;

// Seconds before "Resend code" becomes clickable again.
export const RESEND_SECONDS = 120;

// Single email pattern for the whole block. The login page and the profile page
// previously used two different expressions; this is the stricter of the two,
// so an address like "a@b@c.d" is now rejected in both places instead of only one.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
